module.exports = __webpack_public_path__ + "static/media/diesel-mech.a94bd181.jpg";